import axios from 'axios'
import url from '../../pages/goTicket_new/url.js'
import { Indicator, Toast } from 'mint-ui'
var instance = axios.create()

let root = url
// if (
//     location.origin === 'https://app5share.shouqiev.com' ||
//     location.origin === 'https://app5share1.shouqiev.com' ||
//     location.origin === 'https://app5share2.shouqiev.com' ||
//     location.origin === 'https://app5share3.shouqiev.com' ||
//     location.origin === 'https://app5share4.shouqiev.com' ||
//     location.origin === 'https://app5share5.shouqiev.com'
// ) {
//     root = location.origin + '/backendapi'
// }
instance.defaults.baseURL = root

instance.interceptors.request.use(
    config => {
        // console.log(config)
        !config.noLoading && Indicator.open()
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

// http response 拦截器
instance.interceptors.response.use(
    (response) => {
        console.log(9911,response)
        if (!response.config.noToast && response.data && response.data.code && response.data.code !== 200) {
            Toast(response.data.message)
        }
        Indicator.close()
        return response
    },
    (error) => {
        Indicator.close()
        return Promise.reject(error)
    }
)

export default instance;



// WEBPACK FOOTER //
// src/libs/http/axios-others.js